import React, {useState} from 'react';
import {
  IonBadge,
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonSegment,
  IonSegmentButton,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import {useContagemAprovacoesPendentes, useUserTipo} from '../../lib/DataHooks/transferencias';
import HistoricoTransferenciasPage from './HistoricoTransferenciasPage';
import RealizarTransferenciaPage from './RealizarTransferenciaPage';
import TransferenciaParcialPage from './TransferenciaParcialPage';
import styles from './TransferenciasPage.module.css';

const TransferenciasPage: React.FC = () => {
  const {isGestor, podeAbrirTransferencia} = useUserTipo();
  const [tab, setTab] = useState<string>(podeAbrirTransferencia ? 'realizar' : 'historico');
  const {completas, parciais} = useContagemAprovacoesPendentes();

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonMenuButton/>
          </IonButtons>
          <IonTitle>Transferências</IonTitle>
        </IonToolbar>
        <IonToolbar>
          <IonSegment
            className={styles.segment}
            value={tab}
            onIonChange={e => setTab(e.detail.value as string)}
          >
            {podeAbrirTransferencia && (
              <IonSegmentButton value="realizar">
                <span className="flex items-center justify-center gap-2 whitespace-normal">
                  Realizar Transferência
                  {completas > 0 && <IonBadge color="danger" className='rounded-full'>{completas}</IonBadge>}
                </span>
              </IonSegmentButton>
            )}
            {podeAbrirTransferencia && (
              <IonSegmentButton value="parcial">
                <span className="flex items-center justify-center gap-2 whitespace-normal">
                  Transferência Parcial
                  {parciais > 0 && <IonBadge color="danger" className='rounded-full'>{parciais}</IonBadge>}
                </span>
              </IonSegmentButton>
            )}
            <IonSegmentButton value="historico">
              Histórico
            </IonSegmentButton>
          </IonSegment>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        {isGestor && (tab === 'realizar' || tab === 'parcial') && (
          <div className="bg-blue-100 p-3 m-2 rounded text-sm">
            Como gestor, suas transferências ficam restritas aos usuários sob sua responsabilidade e dependem
            de aprovação do admin antes de serem executadas.
          </div>
        )}

        {tab === 'realizar' && podeAbrirTransferencia && <RealizarTransferenciaPage/>}
        {tab === 'parcial' && podeAbrirTransferencia && <TransferenciaParcialPage/>}
        {tab === 'historico' && <HistoricoTransferenciasPage/>}
      </IonContent>
    </IonPage>
  );
};

export default TransferenciasPage;
